function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as p } from "./index.es33.js";
import { clsx as u } from "./index.es105.js";
import { Typography as i } from "./index.es35.js";
import "./index.es36.js";
import o from "./index.es582.js";

var j = function j(_ref) {
  var _u;

  var s = _ref.placeholder,
      e = _ref.isPale,
      m = _ref.searchValue,
      l = _ref.onChangeSearch,
      r = _ref.isSearchable,
      n = _ref.isTruncated,
      t = _ref.isOpen;
  return p.jsxs("div", {
    className: u(o.wrapper, (_u = {}, _defineProperty(_u, o.wrapperPale, e), _defineProperty(_u, o.wrapperTruncated, n), _u)),
    onClick: function onClick(a) {
      return t && r && a.stopPropagation();
    },
    children: [(!t || !r) && s, t && r && p.jsx(i.Body2, {
      as: "input",
      autoFocus: !0,
      className: o.input,
      value: m,
      onChange: function onChange(a) {
        return l === null || l === void 0 ? void 0 : l(a.target.value);
      }
    })]
  });
};

export { j as SearchableControl };